import Vue from "vue";
import VueRouter from "vue-router";
import SpaceView from "../views/SpaceView.vue";
import LoginView from "../views/LoginView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: '/',
    name: 'space',
    component: SpaceView
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
